import { get } from '../index'

export default {
  get: (params) => get(`statistics`, params)
}
